import Main from "./Components/Main"
const App = () => {
    return(
        <Main/>
    )
}
export default App